import { IParsedMessage, TMessagesMap } from '../../types/messages';

interface IUpdateMessageIndexInMapParams {
  chatMessages: IParsedMessage[];
  messagesMap: TMessagesMap;
}

/** Обновляет индексы сообщений в карте после их сортировки по дате. */
export const updateMessageIndexInMap = ({ chatMessages, messagesMap }: IUpdateMessageIndexInMapParams) =>
  chatMessages
    .sort((a, b) => a.message.created - b.message.created)
    .forEach((message, messageIndex) =>
      messagesMap.set(message.messageId, {
        message,
        messageIndex,
      }),
    );
